import React from 'react';
import { Grid, InputLabel, OutlinedInput } from '@mui/material';
import { FormSectionTitle } from '../../../../components/form-page-parts';
import { ValidationErrors } from '../../../../utils/validation';
import { SupplierFields } from '../../shared/supplier-fields';
import { ContractField } from '../context/contract-validation';
import { IContractAddEditRequest } from '../../../../model/scp/contract/request/contract-add-edit-request';

// Fornecedor contratado, subcontratado (opcional) e dados do CIP (opcional)
export function ContractSupplierSection({ request, errors, onChange }: {
    request: IContractAddEditRequest; errors: ValidationErrors<ContractField>; onChange: (e: any) => void;
}) {
    return (
        <React.Fragment>
            <Grid item xs={12}>
                <FormSectionTitle title="Dados do Fornecedor" />
            </Grid>
            <SupplierFields
                required
                names={{ type: 'select-supplier-type', document: 'input-supplier-number-identification', name: 'input-supplier-name' }}
                type={request.supplierType}
                document={request.supplierNumberIdentification}
                name={request.supplierName}
                onChange={onChange}
                errors={{ type: errors.supplierType, document: errors.supplierNumberIdentification, name: errors.supplierName }}
            />

            <Grid item xs={12}>
                <FormSectionTitle title="Fornecedor Subcontratado (Opcional)" />
            </Grid>
            <SupplierFields
                labelSuffix=" Subcontratado"
                names={{ type: 'select-supplier-type-subcontract', document: 'input-supplier-number-identification-subcontract', name: 'input-supplier-name-subcontract' }}
                type={request.supplierTypeSubContract}
                document={request.supplierNumberIdentificationSubContract}
                name={request.supplierNameSubContract}
                onChange={onChange}
            />

            <Grid item xs={12}>
                <FormSectionTitle title="Dados CIP (Opcional)" />
            </Grid>
            <Grid item xs={12} md={4}>
                <InputLabel>Identificador no CIP</InputLabel>
                <OutlinedInput fullWidth autoComplete="off" name="input-identfiy-cipi" value={request.identifyCIPI || ''} onChange={onChange} />
            </Grid>
            <Grid item xs={12} md={8}>
                <InputLabel>URL no CIP</InputLabel>
                <OutlinedInput fullWidth autoComplete="off" name="input-url-cipi" value={request.urlCIPI || ''} onChange={onChange} />
            </Grid>
        </React.Fragment>
    );
}
